export const USER_INPUT = "USER_DETAILS";
export const USER_INPUT_ERROR = "USER_DETAILS_ERROR";

export const CLASSIFY_IMAGE = "CLASSIFY_IMAGE";
export const CLASSIFY_IMAGE_ERROR = "CLASSIFY_IMAGE_ERROR";

export const USER_INPUT_TEST = "USER_DETAILS_TEST";
export const USER_INPUT_TEST_ERROR = "USER_INPUT_TEST_ERROR";